export const ListSidebar = [
    {
        index:0,
        key:"home"
    },
    {
        index:1,
        key:"learningJourney"
    },
    {
        index:2,
        key:"contentLibrary"
    },
    {
        index:3,
        key:"leaderboards"
    },
    {
        index:4,
        key:"rewards"
    },
    {
        index:5,
        key:"teamMonitoring"
    },
    {
        index:6,
        key:"reviews"
    },
    {
        index:7,
        key:"help"
    },
    {
        index:8,
        key:"scan"
    }
    
]